export class Counter {

    constructor(private container: JQuery) {
        this.container.find('.paragraph-fact .number').each((_, el) => {
            let ele = $(el);
            if(!ele.data('value')) {
                ele.attr('data-value', ele.text());
                ele.text('0');
            }
        });

        this.container.on('observer.in', () => {
            this.container.off('observer.in');
            this.container.find('.paragraph-fact').each((_, el) => this.initFact($(el)));
        });
    }

    private initFact(element: JQuery): void {
        const endValue: number = parseInt(element.find('.number').data('value'), 10);
        const startTime: number = performance.now();

        const tick = (now: number) => {
            const elapsed: number = now - startTime;
            const progress: number = Math.min(elapsed / 1500, 1);
            const eased: number = 1 - Math.pow(1 - progress, 3);
            const current: number = Math.round(eased * endValue);

            element.find('.number').text(current);

            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        };

        requestAnimationFrame(tick);
    }
}
export {};